import moment from "moment";
import { useEffect, useState } from "react";
import AuctionBase from "../AuctionBase";
import React from "react";

import { getProto } from "../../../utils/proto/index";

export const NormalAuction = ({
  auction,
  shopId,
  productId,
  now,
  endEpoch,
  onPlaceBid,
  customerId,
  shopLoginUrl,
  statefulPurchaseQuantity,
  setStatefulPurchaseQuantity,
  setVariant,
}) => {
  const [statefulBids, setStatefulBids] = useState([]);

  const [timeLeft, setTimeLeft] = useState(
    endEpoch > now
      ? moment(endEpoch * 1000).unix() - moment(now * 1000).unix()
      : 0
  );

  useEffect(() => {
    if (getProto(window.location.search)) {
      setStatefulBids([
        {
          price: 10,
        },
        {
          price: 20,
        },
        {
          price: 50,
        },
      ]);
    }
  }, []);

  useEffect(() => {
    if (timeLeft > 0) {
      let refresh = setTimeout(() => {
        setTimeLeft(timeLeft - 1);
        if (timeLeft % 2 === 0) {
          if (getProto(window.location.search)) {
            // simulate new bids

            const _currentPrice = statefulBids.reduce(function (prev, current) {
              return prev.price > current.price ? prev : current;
            }).price;

            setStatefulBids([
              ...statefulBids,
              {
                price: Math.floor(
                  Math.random() * (_currentPrice + 20 - _currentPrice + 1) +
                    _currentPrice
                ),
              },
            ]);
          }
        }
      }, 1000);
      return () => clearTimeout(refresh);
    }
  }, [timeLeft, shopId, productId, statefulBids]);

  return (
    <AuctionBase
      auction={auction}
      currentPrice={
        statefulBids.length > 0
          ? statefulBids.reduce(function (prev, current) {
              return prev.price > current.price ? prev : current;
            }).price
          : 0
      }
      targetDate={endEpoch}
      statefulPurchaseQuantity={statefulPurchaseQuantity}
      setStatefulPurchaseQuantity={setStatefulPurchaseQuantity}
      onBidClick={onPlaceBid}
      setVariant={setVariant}
    />
  );
};
